export default __webpack_public_path__ + "audio/ef3914272428a8269eeb848ee423bd77-flyNoise.wav";